import localEatsActions from './actions';

const INITIAL_DATA = {
  data: null,
  filters: null,
  brands: null,
  offers: null,
  loading: true,
  error: null,
};
export default function localEatsReducer(state = INITIAL_DATA, action) {
  switch (action.type) {
    case localEatsActions.FETCH_MARKETPLACE_DATA_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: null,
      };
    case localEatsActions.FETCH_MARKETPLACE_BRANDS_SUCCESS:
    case localEatsActions.FETCH_MARKETPLACE_FILTER_BRANDS_SUCCESS:
      return {
        ...state,
        brands: action.payload.brands,
        loading: false,
        error: null,
      };
    case localEatsActions.FETCH_MARKETPLACE_OFFERS_SUCCESS:
      return {
        ...state,
        offers: action.payload.offers,
        loading: false,
        error: null,
      };
    case localEatsActions.FETCH_MENU_FILTER_SUCCESS:
      return {
        ...state,
        filters: action.payload,
        loading: false,
        error: null,
      };
    case localEatsActions.FETCH_MENU_FILTER_FAILURE:
    case localEatsActions.FETCH_MARKETPLACE_DATA_FAILURE:
    case localEatsActions.FETCH_MARKETPLACE_BRANDS_FAILURE:
    case localEatsActions.FETCH_MARKETPLACE_OFFERS_FAILURE:
    case localEatsActions.FETCH_MARKETPLACE_FILTER_BRANDS_FAILURE:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
}
